module.exports = __webpack_public_path__ + "img/1.01a2a4b9.png";